import { getAccessToken } from "../utils/storage";

/**
 * Retrieves the current user's Auth0 access token from storage.
 * This approach works outside of React component context.
 *
 * @returns A Promise that resolves to the access token (string)
 *          or `undefined` if the token could not be fetched.
 */
export const getAuthToken = async (): Promise<string | undefined> => {
  try {
    const token = await getAccessToken();
    return token || undefined;
  } catch (err) {
    // If something goes wrong, log the error and return undefined
    console.error("Failed to get token:", err);
    return undefined;
  }
};
